import * as React from "react";

function SvgIcons8602(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <path
        transform="rotate(90 16 0)"
        fill="url(#icons8-\u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C-60_2_svg__pattern0)"
        fillOpacity={0.5}
        d="M16 0h16v16H16z"
      />
      <defs>
        <pattern
          id="icons8-\u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C-60_2_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#icons8-\u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C-60_2_svg__image0"
            transform="scale(.01667)"
          />
        </pattern>
        <image
          id="icons8-\u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C-60_2_svg__image0"
          width={60}
          height={60}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABmJLR0QA/wD/AP+gvaeTAAAA8ElEQVRoge3YywrCMBRF0e0fqigO9OsVQfHxAwo6qAekpKI2Ng/Pgk5v7iajFMzMzMzMzMzM/tEcOAJbYJx4l5AJsAPOwKLvsBFwAG6P7xJjaEQLmp2034lm5172TwNzim7H3mh27W0aGJw6OhR7odk1ilnggCuwinXAB+YduyxjH5RD9GCxkjJ68FhJEZ0sVoaMTh4rQ0RnEyu/jM4uVn4RnW2sxIzOPlZiRBcTK32ii4uVb6KLjZVPoouPlXeiq4mVV9HVxUrX2zW3N3ZUoZuu7mbbuqKrjJV2dNWxMgY2wJo8f/uamZmZmZmZmRXmDg8/7S7HihANAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
}

export default SvgIcons8602;